import { inject, Injectable } from '@angular/core';
import { Analytics, logEvent, setConsent } from '@angular/fire/analytics';


@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor() {}
  private analytics = inject(Analytics);

  public initialize(initialConsentStatus: boolean) { 
    const cookieConsentStatus = initialConsentStatus ? 'granted' : 'denied';
    try {
      setConsent({
        ad_user_data: cookieConsentStatus,
        ad_personalization: cookieConsentStatus,
        ad_storage: cookieConsentStatus,
        analytics_storage: cookieConsentStatus,
        wait_for_update: 500,
      });
    
    } catch (e) {
      console.error('Error adding Google Analytics', e);
    }
  }

  // use logEvent to send Google Analytics Events
  public event(
    eventName: string,
    eventCategory?: string,
    eventLabel?: string,
    value?: string
  ) {
   logEvent(this.analytics, eventName, {
      event_category: eventCategory,
      event_label: eventLabel,
      value: value,
    });
  }

  public grantAnalyticsConsent() {
   setConsent({
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      ad_storage: 'granted',
      analytics_storage: 'granted',
    });
  }
}
